import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './Title.scss';

const Title = ({centerText, className, id, large, small, title, withExpander=false, ...props}) => {
    
    const classValue = classNames(
        "title",
        {"col-xs-12": !className},
        {"center-text" : centerText},
        {"title-expander": withExpander},
        className
    );
    
    const classValueForTitle = classNames(
        {"small" : small},
        {"large" : large}
    );
    
    return(
        <div 
            className={classValue}
            id={id}
            {...props}>
                <label className={classValueForTitle}> 
                    {title}
                    {withExpander && <span className="caret" />}
                </label>
            <hr className="title-underline"/>
        </div>
    );
};

Title.propTypes = {
    centerText: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    large: PropTypes.bool,
    small: PropTypes.bool,
    title: PropTypes.string,
    withExpander: PropTypes.bool
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/base/Title/Title.js